module.exports = __webpack_public_path__ + "static/media/Icon-Edit.bec81ca0.svg";